export const environment = {
    isProduction: false,
    isStaging: true,
    apiBaseUrl: "https://lead-ordrebog-staging.northeurope.azurecontainer.io/api",
    economicInstallUrl:"https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=1xhi9rw50ew4KGG668GWirmaj4naf5NLSgArNFBdbT41",
    azureAdClientId: "79277651-a13e-4abc-a8ce-c42db3ebc526",
    azureAdProtectedResource: "https://lead-ordrebog-staging.northeurope.azurecontainer.io"
};
